function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M23.2,30.6c0,0.8-0.4,1.6-1.2,1.9l-0.9,0.2c-0.5,0-0.9-0.2-1.3-0.5L8.3,22.7H2.1c-1.2,0-2.1-0.9-2.1-2.1 c0,0,0,0,0,0v-8.4C-0.1,11,0.8,10.1,2,10c0,0,0.1,0,0.1,0h6.2l11.5-9.5C20.4,0,21.3-0.1,22,0.2c0.8,0.3,1.2,1.1,1.2,1.9V30.6z"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M50.8,6.6L50.8,6.6c-0.8-0.8-2.1-0.8-2.9,0l-6.6,6.7l-6.7-6.7c-0.7-0.8-1.9-0.8-2.7-0.1c0,0-0.1,0.1-0.1,0.1 l0,0C31,7.3,31,8.5,31.7,9.3c0,0,0.1,0.1,0.1,0.1l6.7,6.7l-6.7,6.7c-0.8,0.7-0.8,1.9-0.1,2.7c0,0,0.1,0.1,0.1,0.1l0,0 c0.7,0.8,1.9,0.8,2.7,0.1c0,0,0.1-0.1,0.1-0.1l6.7-6.7l6.6,6.7c0.8,0.8,2.1,0.8,2.9,0l0,0c0.7-0.8,0.7-2,0-2.8l-6.7-6.7l6.7-6.7 C51.5,8.6,51.5,7.4,50.8,6.6z"
});

function SvgInterviewPageMute(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Fond",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 51.3 32.7",
    style: {
      enableBackground: "new 0 0 51.3 32.7"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInterviewPageMute);
export default __webpack_public_path__ + "static/media/interview-page-mute.90d75506.svg";
export { ForwardRef as ReactComponent };